






import {Component, Vue} from 'vue-property-decorator';
import {UIStore} from '../store';

/**
 * shared network connection lost message
 */
@Component
export default class NetworkConnectivityBanner extends Vue {
	get hasConnection() {
		return UIStore.hasConnection;
	}
}
